"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrTravelDatesSkeletonDesktop = exports.FdrTravelDatesSkeletonMobile = exports.desktopCircles = exports.desktopRects = exports.mobileRects = void 0;
const react_1 = __importDefault(require("react"));
const components_common_content_loader_1 = require("@hotelplan/components.common.content-loader");
exports.mobileRects = [
    // x, y,   w,   h,  rx
    [15, 28, 93, 18, 4],
    [144, 16, 200, 42, 21],
    [15, 85, 77, 18, 4],
    [144, 74, 200, 40],
    [29, 137, 21, 17, 8.5],
    [76, 137, 21, 17, 8.5],
    [123, 137, 21, 17, 8.5],
    [169, 137, 21, 17, 8.5],
    [216, 137, 21, 17, 8.5],
    [263, 137, 21, 17, 8.5],
    [309, 137, 21, 17, 8.5],
    [264, 192, 80, 21, 10],
    [169, 228, 175, 21, 10],
    [15, 278, 329, 21, 10],
    [15, 328, 329, 21, 10],
    [15, 378, 329, 21, 10],
    [15, 428, 329, 21, 10],
];
exports.desktopRects = [
    [27, 34, 103, 14],
    [143, 107, 103, 21],
    [190, 207, 167, 21, 10.5],
    [572, 206, 167, 21, 10.5],
    [415, 255, 324, 21, 10.5],
    [415, 305, 324, 21, 10.5],
    [415, 357, 324, 21, 10.5],
    [415, 405, 324, 21, 10.5],
    [415, 453, 324, 21, 10.5],
    [26, 255, 324, 21, 10.5],
    [26, 305, 324, 21, 10.5],
    [26, 357, 324, 21, 10.5],
    [26, 405, 324, 21, 10.5],
    [26, 453, 324, 21, 10.5],
    [258, 520, 247, 15],
    [524, 107, 103, 21],
    [412, 34, 103, 14],
    [544, 22, 199, 37],
    [159, 21, 198, 41, 0.5],
];
exports.desktopCircles = [
    [39, 117, 12],
    [140, 168, 10],
    [191, 168, 10],
    [242, 168, 10],
    [293, 168, 10],
    [340, 168, 10],
    [42, 168, 10],
    [93, 168, 10],
    [521, 168, 10],
    [572, 168, 10],
    [623, 168, 10],
    [674, 168, 10],
    [721, 168, 10],
    [423, 168, 10],
    [474, 168, 10],
    [730, 117, 12],
];
function FdrTravelDatesSkeletonMobile() {
    return (react_1.default.createElement(components_common_content_loader_1.ContentLoader, { w: [360], h: [480], uid: "t-dates-mobile", rects: exports.mobileRects }));
}
exports.FdrTravelDatesSkeletonMobile = FdrTravelDatesSkeletonMobile;
function FdrTravelDatesSkeletonDesktop() {
    return (react_1.default.createElement(components_common_content_loader_1.ContentLoader, { w: [770], h: [548], uid: "t-dates-desktop", rects: exports.desktopRects, circles: exports.desktopCircles }));
}
exports.FdrTravelDatesSkeletonDesktop = FdrTravelDatesSkeletonDesktop;
//# sourceMappingURL=fdr-travel-dates.skeleton.js.map